export default class MinCostPerSquareFootVersionResponse {
    public completedDate: Date | null = null;
    public createdDate: Date | null = null;
    public description : string = String.empty();
    public id: number | null = null;
    public userIdCompletedBy: number | null = null;
    public userIdCreatedBy: number | null = null;
    public constructor() {
    }
};